import { render } from "./Gospel.vue?vue&type=template&id=5e05fa5c&scoped=true"
import script from "./Gospel.vue?vue&type=script&lang=js"
export * from "./Gospel.vue?vue&type=script&lang=js"

import "./Gospel.vue?vue&type=style&index=0&id=5e05fa5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e05fa5c"

export default script